export const todosTipoPeriodo = [
  { type: 3, value: 'year', label: 'Anual' },
  { type: 2, value: 'month', label: 'Mensal' },
  { type: 1, value: 'week', label: 'Semanal' },
  { type: 1, value: '', label: 'Diário' },
];
